exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_d185ce3,.inputW2_4b64526{width:400px!important}.inputW2_4b64526{display:inline-block!important;margin:0 30px 10px 0}.btnW_7c936dd{width:110px}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_d185ce3",
	"inputW2": "inputW2_4b64526",
	"btnW": "btnW_7c936dd"
};